"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PreviewAction = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var clsx_1 = __importDefault(require("clsx"));
var PreviewAction = function (_a) {
    var children = _a.children, verticallyCentered = _a.verticallyCentered, visible = _a.visible;
    return ((0, jsx_runtime_1.jsx)("button", __assign({ className: (0, clsx_1.default)("absolute flex rounded-full text-white text-center z-10 text-small bg-sorbus-default", verticallyCentered && "-mt-2", visible ? "opacity-100" : "opacity-0"), style: { width: "2rem", height: "2rem", right: 4 } }, { children: (0, jsx_runtime_1.jsx)("label", __assign({ className: "m-auto" }, { children: children }), void 0) }), void 0));
};
exports.PreviewAction = PreviewAction;
